import { type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { type QuestionEditorViewModel } from '@/features/jobs/questions/QuestionEditorViewModel'
import { QuestionEditorCompactItem } from '@/features/jobs/questions/components/QuestionEditorCompactItem'

export interface QuestionEditorCompactItemContainerProps {
  vm: QuestionEditorViewModel
  children?: ReactNode
}

export const QuestionEditorCompactItemContainer = observer(
  function QuestionEditorCompactItemContainer({
    vm,
    children,
  }: QuestionEditorCompactItemContainerProps) {
    return (
      <QuestionEditorCompactItem
        title={vm.title}
        description={vm.description}
        validationErrors={vm.validationErrors}
      >
        {children}
      </QuestionEditorCompactItem>
    )
  },
)
